import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { withTheme } from 'styled-components';
import { CSVLink } from 'react-csv';
import publicationService from 'services/PublicationService';
import {
  Button,
  MaterialIcon,
  SVGIcon,
  Spinner,
} from '@pearsontechnology/aero-components';

import messages from '../messages';
import {
  Card,
  CardHearder,
  CloseWrapper,
  SaveButton,
  ReleaseDate,
  Version,
  CardHeaderItem,
  VersionCompareTable,
  TableHeader,
  TableHeaderItems,
  TableRow,
  TableData,
  CardContentWrapper,
  SortButton,
} from './styles';

const reportHeaders =  ['Plugin level', 'Title', 'Change'];


/**
 * @desc Renders publications version comparsion
 */
const PublicationVersionCompare = ({ onClose, selectedPublications }) => {

  const [compareData, setCompareData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });

  const sortBy = (index) => {
    let direction = 'asc';
    if (sortConfig.key === index && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
  
    const sortedData = [...compareData].sort((a, b) => {
      if (a[index] < b[index]) return direction === 'asc' ? -1 : 1;
      if (a[index] > b[index]) return direction === 'asc' ? 1 : -1;
      return 0;
    });
  
    setSortConfig({ key: index, direction });
    setCompareData(sortedData);
  };

  useEffect(() => {
    async function fetchDiff() {
      const publicationAId = selectedPublications[0].publicationId;
      const activityId = selectedPublications[0].activityId;
      const publicationBId = selectedPublications[1].publicationId;
      const { diffs } = await publicationService.getPublicationVersionDiff(activityId, publicationAId, publicationBId);
      setCompareData( diffs ? diffs : []);
      setLoading(false);
    }

    fetchDiff();
  },[selectedPublications]);

  return (
    <Card>
      <CloseWrapper>
        <Button
          grey
          iconOnly
          aria-label={intl.formatMessage(messages.close)}
          onClick={() => onClose(false)}
        >
          <MaterialIcon id="close" />
        </Button>
      </CloseWrapper>
      <CardHearder>
        <CardHeaderItem>
          <Version>Version {selectedPublications[0].version}</Version>
          <ReleaseDate> { JSON.parse(selectedPublications[0].description).type }: {selectedPublications[0].time}</ReleaseDate>
        </CardHeaderItem>
        <CardHeaderItem>
          <Version>Version {selectedPublications[1].version}</Version>
          <ReleaseDate> {JSON.parse(selectedPublications[1].description).type}: {selectedPublications[1].time}</ReleaseDate>
        </CardHeaderItem>
        <CardHeaderItem>
          <CSVLink data={[reportHeaders, ...compareData]} filename={`${selectedPublications[0].title}_Compare_Report.csv`} >
            <SaveButton>{intl.formatMessage(messages.save)} <SVGIcon icon="download"/></SaveButton>
          </CSVLink>
        </CardHeaderItem>
      </CardHearder>
      <CardContentWrapper>
        {isLoading ? (
          <Spinner />
        ) : (
          <VersionCompareTable>
            <thead>
              <TableRow>
                <TableHeader>
                  <TableHeaderItems>
                    Plugin level
                    <SortButton
                      id={"Plugin level"}
                      sort={
                        sortConfig.key === 0
                          ? sortConfig.direction === "asc"
                            ? "asc"
                            : "desc"
                          : ""
                      }
                      onClick={() => sortBy(0)}
                    />
                  </TableHeaderItems>
                </TableHeader>
                <TableHeader>
                  <TableHeaderItems>
                    Title
                    <SortButton
                      id={"Title"}
                      sort={
                        sortConfig.key === 1
                          ? sortConfig.direction === "asc"
                            ? "asc"
                            : "desc"
                          : ""
                      }
                      onClick={() => sortBy(1)}
                    />
                  </TableHeaderItems>
                </TableHeader>
                <TableHeader>
                  <TableHeaderItems>
                    Change
                    <SortButton
                      id={"Change"}
                      sort={
                        sortConfig.key === 2
                          ? sortConfig.direction === "asc"
                            ? "asc"
                            : "desc"
                          : ""
                      }
                      onClick={() => sortBy(2)}
                    />
                  </TableHeaderItems>
                </TableHeader>
              </TableRow>
            </thead>
            <tbody>
              {
                compareData.length ? (
                  compareData.map((item, index) => (
                    <TableRow key={index}>
                      <TableData>{item[0]}</TableData>
                      <TableData>{item[1]}</TableData>
                      <TableData>{item[2]}</TableData>
                    </TableRow>
                  )))
                  :
                  <TableRow>
                    <TableData colSpan={3} textAlign={'center'}>
                      {intl.formatMessage(messages.noChange)}
                    </TableData>
                  </TableRow>
              }
            </tbody>
          </VersionCompareTable>
        )}
      </CardContentWrapper>
    </Card>);
};

PublicationVersionCompare.propTypes = {
  theme: PropTypes.object,
};

export default withTheme(PublicationVersionCompare);